import React from 'react';
import { TypeDiagnoBagDataStore } from '../../../states/tableData';
import PaginationComponent from '../../../components/paginationComponent/PaginationComponent';

export const Pagination = () => {
    const { dataListConfig, modifyDataListConfig, fetchList } = TypeDiagnoBagDataStore();

    const handlePageClick = (event) => {
        console.log(event);
        modifyDataListConfig({ page: event });
        fetchList(dataListConfig.perPageItems, event)
    };

    const setperPageItems = (event) => {
        modifyDataListConfig({ perPageItems: event });
        fetchList(event, dataListConfig.page)
    };

    return (
        <div>
            <PaginationComponent
                page={dataListConfig?.page}
                element={"pagination"}
                handlePageClick={handlePageClick}
                totalItems={dataListConfig.totalItems}
                perPageItems={dataListConfig?.perPageItems}
                setnumberPerPage={setperPageItems}
                showPagination={true}
            />
        </div>
    );
}

